var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRichTextButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rich-text-button_svg__clip0_183_11087)",
    stroke: "#3A3544",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.836 13.711l-1.5 4.07a.625.625 0 01-1.172 0l-1.5-4.07a.634.634 0 00-.375-.375l-4.07-1.5a.625.625 0 010-1.172l4.07-1.5a.633.633 0 00.375-.375l1.5-4.07a.625.625 0 011.172 0l1.5 4.07a.633.633 0 00.375.375l4.07 1.5a.625.625 0 010 1.172l-4.07 1.5a.633.633 0 00-.375.375v0zM13.75 1.25V5M15.625 3.125h-3.75M17.5 5.625v2.5M18.75 6.875h-2.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rich-text-button_svg__clip0_183_11087"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgRichTextButton;